module.exports = __webpack_public_path__ + "static/media/7ICJ1.84ca5a0f.jpg";